module.exports = __webpack_public_path__ + "img/logo.b1cd5409.png";